import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Microsoft } from "mdi-material-ui";

const Login = () => {
  const handleLogin = () => {
    // ✅ Force full page redirect to trigger Render rewrite
    window.location.replace("/auth/signin");
  };

  return (
    <Box
      height="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      bgcolor="#187089" // ✅ Updated background color
    >
      <Typography variant="h4" gutterBottom color="white">
        Welcome to KBS Support
      </Typography>
      <Typography variant="subtitle1" gutterBottom color="white">
        Please sign in to continue
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<Microsoft />}
        onClick={handleLogin}
        sx={{ mt: 2 }}
      >
        Sign in with Microsoft
      </Button>
    </Box>
  );
};

export default Login;